import type { TeamWithFixtures } from '@api-service/team-fixtures';
import { GAMEWEEK_ONE, MAX_GAMEWEEK } from '@lib/constants';

// Minimal per-fixture shape the shared ticker cells render. Both the full
// `TeamFixture` (from the authenticated endpoint) and the preview fixture
// (from the public mini-ticker endpoint) are assignable to it, so the cells,
// rows, and grouping helper work for either source.
export type FixtureCellData = {
  gameweek: number;
  kickoffAt: string | null;
  venue: 'home' | 'away';
  opponent: { name: string; shortName: string };
  inferences?: {
    difficulty: { attack: number; defence: number; overall: number };
    // Only the authenticated endpoint carries goal and clean-sheet figures;
    // the preview endpoint omits them, hence optional.
    predictions?: { goalsFor: number; goalsAgainst: number };
    probabilities: { cleanSheet?: number; toPlay: number };
  };
};

export type GameweekFixtures = {
  gameweek: number;
  fixtures: FixtureCellData[];
};

export type DifficultyVariant =
  | 'very-easy'
  | 'easy'
  | 'moderate'
  | 'hard'
  | 'very-hard';

export const MIN_GAMEWEEK = GAMEWEEK_ONE;
export { MAX_GAMEWEEK };

export const DEFAULT_GAMEWEEK_HORIZON = 6;

export const FIVE_STAR_SCALE = 5;
export const TEN_POINT_SCALE = 10;

export type { TeamWithFixtures };
